// CORE-496 — pure mapping from a tour step + which button was pressed to the
// intent the provider should run. Split out of OnboardingTourOverlay so the
// button semantics are unit-testable.
import { TOTAL_TOUR_STEPS, TourStep } from './tourSteps';

export type TourIntent = 'next' | 'complete' | 'chat' | 'skip_step' | 'skip_all' | 'close';

/** Intent of the PRIMARY (filled) button for a step. */
export function primaryIntent(step: TourStep): TourIntent {
  return step.primaryAction; // 'next' | 'complete' | 'chat'
}

/** Intent of the SECONDARY (text) button for a step.
 *  On the final step (primary = open chat), the secondary "Завершить знакомство"
 *  means the user finished the whole tour → complete (not a mid-way close). */
export function secondaryIntent(step: TourStep): TourIntent {
  if (step.primaryAction === 'chat') return 'complete';
  return step.secondaryAction; // 'skip_step' | 'skip_all'
}

/**
 * CORE-1750 — что значит крестик (или нажатие на её аватар) на данном шаге.
 *
 * На последнем шаге откладывать нечего: Агапелла уже поблагодарила за
 * знакомство. Записанное как «отложил», такое закрытие через три дня открывало
 * само ровно это «Спасибо, что уделил время знакомству», а прощание «Я
 * запомнила, где мы остановились… Вернуться к знакомству можно в любой момент»
 * говорило человеку, прошедшему тур, что он его не прошёл. Поэтому закрытие
 * там — завершение, как и кнопка «Завершить знакомство».
 */
export function closeIntent(stepId: number): 'complete' | 'close' {
  return stepId >= TOTAL_TOUR_STEPS ? 'complete' : 'close';
}
